import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const TextError = styled.div`
	color: #c53030;
`;

export const TrStyled = styled.tr`
	background: ${color.white};
	/* color: ${color.black} !important; */

	&:hover {
		td{
			background-color: ${color.primary} !important;
			cursor: pointer;
		}
	}

	th {
		padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.white} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const ButtonStyled = styled(Button)`
	background-color: ${color.white} !important;
	border-radius: 7px !important;
	border: 0 !important;
	color: ${color.black} !important;

	margin-bottom: 30px;
	&:hover {
		background-color: ${color.primary} !important;
	}
`;

export const ButtonStyle = styled(Button)`
	//float: right;

	//width: 100%;
	background-color: ${color.yellow};
	border-radius: 15px;
	color: ${color.black};
	border-color: transparent;
`;
